import i18n from "@/i18n";
import AdminLayout from "@/layouts/Admin";
import DashboardWelcome from "@/views/DashboardWelcome";
import Error from "@/views/Error";
import Profile from "@/views/Profile";
import Billing from "@/views/auth/Billing";
import Settings from "@/views/Settings";
import ChangePlan from "@/views/ChangePlan";
import ConfirmOwnershipChange from "@/views/ConfirmOwnershipChange";
import Preview from "@/views/Preview";
import MultiStepQuiz from "@/views/MultiStepQuizDialog";
import MultiStepQuizV2 from "@/views/MultiStepQuizV2Dialog";
import MultiStepQuizV3 from "@/views/MultiStepQuizV3Dialog";
import MultiStepQuizV4 from "@/views/MultiStepQuizV4Dialog";
import CommentsWidget from "@/views/CommentsWidgetDialog";
import ContentSplit from "@/views/ContentSplitDialog";
import ToastDialog from "@/views/ToastDialog.vue";
import LiveChatDialog from "@/views/LiveChatDialog.vue";
import CountdownDialog from "@/views/CountdownDialog.vue";
import LiveChatAutoDialog from "@/views/LiveChatAutoDialog.vue";
import AudioFormDialog from "@/views/AudioFormDialog.vue";
import BottomBarDialog from "@/views/BottomBarDialog.vue";
import DomainPurchase from "@/views/DomainPurchase.vue";
import CompletePayment from "@/views/CompletePayment.vue";
import CompleteBillingMethod from "@/views/CompleteBillingMethod.vue";
import ButtonsWithTextBoxDialog from "@/views/ButtonsWithTextBoxDialog.vue";
import CompleteGoogleAuth from "@/views/CompleteGoogleAuth.vue";
import CompleteFacebookAuth from "@/views/CompleteFacebookAuth.vue";
import AiTools from "@/views/AiTools.vue";
import Vue from "vue";

/**
 * Error component
 */
Vue.component("Error", Error);

export default {
  path: "",
  component: AdminLayout,
  meta: {
    title: i18n.t("routes.home"),
  },
  children: [
    {
      path: "/dashboard",
      name: "dashboard",
      component: DashboardWelcome,
      meta: {
        title: i18n.t("routes.meta_titles.dashboard"),
        layout: "content",
      },
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {
        title: i18n.t("routes.profile"),
        layout: "content",
      },
    },
    ...(() => {
      if (process.env.VUE_APP_INULTI_BUILD !== "true") {
        return [
          {
            path: "/billing/",
            name: "billing",
            component: Billing,
            meta: {
              title: i18n.t("routes.billing"),
              layout: "blank",
              onlyLightTheme: true,
            },
          },
          {
            path: "/change-plan",
            name: "change-plan",
            component: ChangePlan,
            meta: {
              title: i18n.t("routes.meta_titles.change_plan"),
              layout: "content",
            },
          },
          {
            path: "/complete-payment",
            name: "complete-payment",
            component: CompletePayment,
            meta: {
              layout: "blank",
            },
          },
          {
            path: "/complete-billing-method",
            name: "complete-billing-method",
            component: CompleteBillingMethod,
            meta: {
              layout: "blank",
            },
          },
          {
            path: "/complete-google-auth",
            name: "complete-google-auth",
            component: CompleteGoogleAuth,
            meta: {
              layout: "blank",
            },
          },
          {
            path: "/complete-facebook-auth",
            name: "complete-facebook-auth",
            component: CompleteFacebookAuth,
            meta: {
              layout: "blank",
            },
          },
        ];
      } else {
        return [
          {
            path: "/buttons-with-text-box-dialog",
            name: "buttons-with-text-box-dialog",
            component: ButtonsWithTextBoxDialog,
            meta: {
              title: "Buttons With Text-Box Dialog",
              layout: "blank",
              tinymce: true,
            },
          },
        ];
      }
    })(),
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: {
        title: i18n.t("routes.meta_titles.settings"),
        layout: "content",
      },
    },
    {
      path: "/preview",
      name: "preview",
      component: Preview,
      props: route => ({
        domain: route.query.domain,
        slug: route.query.slug,
        version: route.query.version,
      }),
      meta: {
        title: i18n.t("routes.meta_titles.preview"),
        layout: "blank",
        skipBillingDataLoad: true,
      },
    },
    {
      path: "/multi-step-quiz-dialog",
      name: "MultiStepQuiz",
      component: MultiStepQuiz,
      meta: {
        title: "Multi-Step-Quiz",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/multi-step-quiz-v2-dialog",
      name: "MultiStepQuizV2",
      component: MultiStepQuizV2,
      meta: {
        title: "Multi-Step-Quiz-V2",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/multi-step-quiz-v3-dialog",
      name: "MultiStepQuizV3",
      component: MultiStepQuizV3,
      meta: {
        title: "Multi-Step-Quiz-V3",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/multi-step-quiz-v4-dialog",
      name: "MultiStepQuizV4",
      component: MultiStepQuizV4,
      meta: {
        title: "Multi-Step-Quiz-V4",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/toast-dialog",
      name: "ToastDialog",
      component: ToastDialog,
      meta: {
        title: "Toast-Dialog",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/content-split-dialog",
      name: "ContentSplit",
      component: ContentSplit,
      meta: {
        title: "Content Split",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/comments-widget-dialog",
      name: "CommentsWidget",
      component: CommentsWidget,
      meta: {
        title: "Comments-Widget-Dialog",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/live-chat-dialog",
      name: "LiveChat",
      component: LiveChatDialog,
      meta: {
        title: "Live Chat",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/countdown-dialog",
      name: "Countdown",
      component: CountdownDialog,
      meta: {
        title: "Countdown",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/live-chat-auto-dialog",
      name: "LiveChatAuto",
      component: LiveChatAutoDialog,
      meta: {
        title: "Live Chat - Auto",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/audio-form-dialog",
      name: "AudioForm",
      component: AudioFormDialog,
      meta: {
        title: "Audio Form",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/bottom-bar-dialog",
      name: "BottomBar",
      component: BottomBarDialog,
      meta: {
        title: "Bottom Bar",
        layout: "blank",
        tinymce: true,
      },
    },
    {
      path: "/confirm-change-ownership/:organizationId/:token",
      name: "confirm_change_ownership",
      component: ConfirmOwnershipChange,
      meta: {
        title: i18n.t("routes.confirm_change_ownership"),
        layout: "blank",
      },
    },
    {
      path: "/domain-purchase",
      name: "domain_purchase",
      component: DomainPurchase,
      meta: {
        title: i18n.t("routes.purchase_domain"),
        layout: "content",
      },
    },
    {
      path: "/ai-tools",
      name: "ai_tools",
      component: AiTools,
      meta: {
        title: i18n.t("routes.ai_tools"),
        layout: "blank",
      },
    },
    {
      path: "*",
      component: Error,
      meta: {
        title: i18n.t("routes.not_found"),
        layout: "content",
      },
    },
  ],
};
